module.exports = __webpack_public_path__ + "img/ums.e88caaf0.svg";